import { SHOPIFY } from '../constants/cms'
export function pinflagPaymentSuccessEvent (cms) {
  window.parent.postMessage(
    {
      type: 'payment-success',
      origin: cms === SHOPIFY ? 'pinflag-shopify-pinmap-pro' : 'pinflag-checkout-iframe',
      message: true
    },
    '*'
  )
}

export function webpayRedirectEvent (url) {
  window.parent.postMessage(
    {
      type: 'webpay-redirect',
      origin: 'pinflag-checkout-iframe',
      message: { url }
    },
    '*'
  )
}
